import { FC, ReactElement } from "react";
import useShowMoreContext from "./use-show-more-context";
import { ShowMoreContextType } from "./show-more-context";

export interface ShowMoreContextComponentProps {
  children(props: ShowMoreContextType): ReactElement;
}

const ShowMoreContextComponent: FC<ShowMoreContextComponentProps> = ({
  children,
}) => {
  const context = useShowMoreContext();
  return children(context);
};

export default ShowMoreContextComponent;
